import api, { callRefreshToken } from "../config/http-common";

export const TotalDurationWeek = async (payload) => {
  let url = "/events/totalDurationWeek";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  url += "&companyId=" + payload.companyId;

  if (payload?.userId) {
    url += "&userId=" + payload.userId;
  }
  if (payload?.departmentId) {
    url += "&departmentId=" + payload.departmentId;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(url);
};

export const listApplication = async (payload) => {
  let url = "/events/application";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  if (payload?.companyId) {
    url += "&companyId=" + payload.companyId;
  }
  if (payload?.userId) {
    url += "&userId=" + payload.userId;
  }
  if (payload?.departmentIds) {
    url += "&departmentIds=" + payload.departmentIds;
  }
  if (payload?.projectIds) {
    url += "&projectIds=" + payload.projectIds;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(url);
};

export const listDashboardProject = async (payload) => {
  let url = "/report/project";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  if (payload?.userId) {
    url += "&userId=" + payload.userId;
  }
  if (payload?.departmentIds) {
    url += "&departmentIds=" + payload.departmentIds;
  }
  if (payload?.projectIds) {
    url += "&projectId=" + payload.projectIds;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(url);
};

export const listProjectsReport = async (startTime, endTime) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api
      .securedAxios()
      .get("/report/project?startTime=" + startTime + "&endTime=" + endTime);
};

export const getMostActiveAndIdleUsers = async (payload) => {
  let url = "/dashboard/most_active_inactive_users";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  if (payload?.departmentId) {
    url += "&departmentIds=" + payload.departmentId;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const getUserPreferences = async (userId) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(
      process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + `/users/${userId}/preferences`);
};

export const updateUserPreferences = async (userId, payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().put(
      process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + `/users/${userId}/preferences`, payload);
};

export const resetUserPreferences = async (userId, payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().put(
      process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + `/users/${userId}/reset-preferences`, payload);
};

export const getMostActiveUsers = async (payload) => {
  let url = "/dashboard/most_active_users";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  if (payload?.departmentId) {
    url += "&departmentIds=" + payload.departmentId;
  }
  if (payload?.projectIds) {
    url += "&projectIds=" + payload.projectIds;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};


export const getMostIdleUsers = async (payload) => {
  let url = "/dashboard/most_idle_users";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  if (payload?.departmentId) {
    url += "&departmentIds=" + payload.departmentId;
  }
  if (payload?.projectIds) {
    url += "&projectIds=" + payload.projectIds;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const getWeeklyActiveTimeSummary = async (payload) => {
  let url = process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + "/dashboard/weekly_active_time_summary";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  if (payload?.userId) {
    url += "&userId=" + payload.userId;
  }
  if (payload?.departmentId) {
    url += "&departmentId=" + payload.departmentId;
  }
  if (payload?.projectIds) {
    url += "&projectIds=" + payload.projectIds;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(url);
};

export const getWeeklyIdleTimeSummary = async (payload) => {
  let url = process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + "/dashboard/weekly_idle_time_summary";
  if (payload?.startTime) {
    url += "?startTime=" + payload.startTime;
  }
  if (payload?.endTime) {
    url += "&endTime=" + payload.endTime;
  }
  if (payload?.userId) {
    url += "&userId=" + payload.userId;
  }
  if (payload?.departmentId) {
    url += "&departmentId=" + payload.departmentId;
  }
  if (payload?.projectIds) {
    url += "&projectIds=" + payload.projectIds;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(url);
};